import React from 'react';
import Sidebar from './Sidebar';
import HunterHeader from './HunterHeader';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../types/hooks';
import { isLoggedIn$ } from '../../store/slices/user';
import { APP_ROUTES } from '../../routes';

const HunterLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
    const navigate = useNavigate();
    const isLoggedIn = useAppSelector(isLoggedIn$);

    if (!isLoggedIn) {
        navigate(APP_ROUTES.login);
        return null;
    }

    return (
        <React.Fragment>
            <div className="d-flex flex-row">
                <Sidebar />
                <div className="h-content">
                    <HunterHeader />
                    {children}
                </div>
            </div>
        </React.Fragment>
    );
};

export default HunterLayout;
